module.exports = __webpack_public_path__ + "img/襄阳市妇幼保健院.54ce8276.png";